import axios from "axios";
// import store from '@/store'
import { getToken, GetTokenKey, getLoginName, GetLoginKey, removeToken, removeLoginName, removeNextTimeRouter } from "@/utils/auth";

import { Notify } from "vant";
import { router } from '../router/router.js'
import enums from '@/utils/enums'

// create an axios instance
var baseURL = ""
if (process.env.NODE_ENV === "development") { // 开发环境
  baseURL = "/api"
} else { // 生产环境
  baseURL = process.env.VUE_APP_BASE_API
}
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: baseURL, // url = base url + request url

  withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});


// request interceptor
service.interceptors.request.use(
  (config) => {
    // config.baseURL = Vue.prototype.appConfig.Service_Url
    // config.withCredentials = true
    if (getToken()) {
      config.headers[GetTokenKey()] = getToken();
    }
    if (getLoginName()) {
      config.headers[GetLoginKey()] = getLoginName();
    }
    return config;
  },
  (error) => {
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    if (response.data.Success) {
      return response.data;
    } else {
      Notify({ type: "danger", message: response.data.Message });
      if (response.data.Message.length > 0) {
        for (const key in enums.LoginStatus) {
          if (response.data.Message === enums.LoginStatus[key].value) {
            setTimeout(() => {
              localStorage.clear()
              removeToken()
              removeLoginName()
              removeNextTimeRouter()
              router.replace('/login')
            }, 1000)
          }
        }
      }
      return response.data;
    }
  },
  (error) => {
    console.log("err", error); // for debug
    if (error.message) {
      Notify({ type: "danger", message: error.message });
    }
    return Promise.reject(error);
  }
);

export default service;
